import React, { useState } from "react";

import AvatarCustom from "../../../../components/AvatarCustom/AvatarCustom";
import GvPrimaryButton from "../../../../components/GvPrimaryButton/GvPrimaryButton";
import { IPetItemResponse } from "../../../../services/pet-list/pet-list.interface";
import { Typography } from "@mui/material";

interface IPrequalPetPickerProps {
  pets: IPetItemResponse[];
  locationName?: string;
  onContinue: (pet: IPetItemResponse) => void;
}

// Inline pet-selection step for the prequalification deep link, laid out to
// match PrequalCustomerInfoForm (same page background, max-width, and CTA).
export const PrequalPetPicker = ({ pets, locationName, onContinue }: IPrequalPetPickerProps) => {
  const [selectedPet, setSelectedPet] = useState<IPetItemResponse>();

  const handleContinue = () => {
    if (!selectedPet) return;
    onContinue(selectedPet);
  };

  return (
    <div className="min-h-full w-full bg-[#F9F6F4]">
      <div className="mx-auto w-full max-w-3xl px-4 py-6">
        <div className="mb-6">
          <Typography variant="h5" sx={{ fontWeight: 600 }}>Select a Pet</Typography>
          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            Choose which pet you&apos;d like to check eligibility for.
          </Typography>
        </div>

        <div className="flex flex-col gap-4">
          {pets.map((pet: IPetItemResponse) => (
            <div
              className={`border-2 rounded-lg p-4 cursor-pointer hover:border-gv-yellow
              ${selectedPet?.id === pet.id ? "border-gv-yellow bg-gv-yellow-light" : "border-taupe-50 bg-white"}`}
              onClick={() => setSelectedPet(pet)}
              key={pet.id}
            >
              <div className="flex gap-3 w-full items-center">
                <div>
                  <AvatarCustom width={70} height={70} image={pet.image} name={pet.name} />
                </div>
                <div className="space-y-1">
                  <div className="font-semibold capitalize">
                    <p>{pet.name}</p>
                  </div>
                  {locationName && (
                    <div className="text-sm flex gap-1">
                      <span>Eligible at</span>
                      <span className="font-semibold">GoodVets {locationName}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mx-auto mt-6 w-full max-w-xs">
          <GvPrimaryButton type="button" isDisabled={!selectedPet} onClick={handleContinue}>
            Continue
          </GvPrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default PrequalPetPicker;
